import { Component, Input } from '@angular/core';
import { CleverTapConstents } from 'src/app/services/constants';
import { TosterMsgType } from 'src/app/services/model';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-p-nach',
  templateUrl: './p-nach.component.html',
  styleUrls: ['./p-nach.component.scss']
})
export class PNachComponent {
  isEnableUpload:boolean =false;
  @Input() isPnachformDownloaded: boolean = false;
  @Input() selectedBanks: any;
  @Input() nachData: any;
  fileIds: string = '';
  isShowReuploadErrMsg: boolean = false;
  constructor(private util: UtilService) { }
  ngOnInit(){
    this.util.cleverTapEventCall(CleverTapConstents.physical_nach_initiated,{});
  }
  uploadDoc(event: any) {
    const uploadedForm = event.target.files[0]
    const formData = new FormData();
    formData.append('file', uploadedForm);
    const currentApplicant = this.util.getCache('currentApplicant');
    this.util.handleRequests('put', this.util.getUrl('attachment_selfie'), formData, undefined, undefined, undefined, false).then((res: any) => {
     if(res.fileId){
      this.fileIds = res.fileId;
      this.isShowReuploadErrMsg = false
     }
      if (res['status'] === 'ERROR') {
        this.util.showToaster(res['content']['message'], TosterMsgType.ERROR);
        this.util.hideWaitingScreen();
      }
    }).catch(() => {
      this.util.hideWaitingScreen();

    });
  }

  downloanForm() {
    this.util.handleRequests('blobFile', this.util.getUrl('loan_physicalNach_downloadForm', [this.util.loanDetails.loanId])).then((res: any) => {
      if (res.blobFile) {
        this.downloadFile(res['blobFile'], 'pNach.pdf');
      }
    });
  }
  pNachSubmit() {
    const loanId = this.util.loanDetails.loanId;
    const fileId = this.fileIds;
    this.util.handleRequests('post', this.util.getUrl('loan_physicalNach_uploadForm', [loanId, fileId])).then(res => {
      if(res.status == 'SUCCESS'){
        //  redirect
        this.util.cleverTapEventCall(CleverTapConstents.physical_nach_completed,{});
        this.util.getProducts().then(res=>{
          this.util.navigationHandler()
        })
      }
    }).catch(err => {
      if(err.error.status == 'ERROR'){
        this.fileIds = '';
        this.isShowReuploadErrMsg = true
        this.util.showToaster(err['error']['content']['message'], TosterMsgType.ERROR);
      }
    })
  }
  downloadFile(blob: any, fileName: any) {
    const link = document.createElement('a');
    link.href = blob;
    link.download = fileName;
    document.body.append(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(link.href), 7000);
    this.isEnableUpload = true;
  };
}
